import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleRevisarPedido = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleRevisarPedido/tarea-detalle-revisar-pedido"
    )
);

export function tareaDetalleRevisarPedido() {
  return (
    <Route
      path="/tarea-detalle-revisar-pedido"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleRevisarPedido />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
